import { call, cancel, select, takeEvery } from 'redux-saga/effects';
import {
  GlobalAction,
  GlobalActions,
  GlobalPut,
  isMaklerbetreuerOrMaklerOrUvm,
  UpdateLoadedVorvertraege,
} from '@ps20-frontend/shop-integration-redux';
import { App, determineZahlungsoptionenChangedPayload } from '@ps20-frontend/frontend-models';
import { ForkEffect } from '@redux-saga/core/effects';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { Zahlungsart } from '@ps20/bff-models';
import { IAppState } from '../localStore';

// NOSONAR

export function* watchUpdateZahlungsweise(): Generator<ForkEffect> {
  yield takeEvery(GlobalActions.UPDATE_VORVERTRAEGE, safeSaga(updateZahlungsweise, App.SHOP));
}

export function* updateZahlungsweise(action: GlobalAction<UpdateLoadedVorvertraege>): unknown {
  const state: IAppState = yield select();
  const globalPut = GlobalPut.getInstance();
  const isMaklerInkasso =
    state.transientState.isInkasso && isMaklerbetreuerOrMaklerOrUvm(state.transientState.role);
  if (
    (state.transientState.avLoaded && !isMaklerInkasso) ||
    (action.payload.standardVorvertraege.length === 0 &&
      action.payload.standaloneVorvertraege.length === 0)
  ) {
    yield cancel();
  }

  if (state.transientState.avLoaded && isMaklerInkasso) {
    yield call(
      globalPut.put,
      new GlobalActions().zahlungsoptionenChanged({
        zahlungsweise: null,
        zahlungsart: Zahlungsart.MAKLER_INKASSO,
      }),
    );
  } else {
    const zahlungsPayload = determineZahlungsoptionenChangedPayload(
      action.payload.standardVorvertraege,
      action.payload.standaloneVorvertraege,
      isMaklerInkasso,
    );
    yield call(
      globalPut.put,
      new GlobalActions().zahlungsoptionenChangedVorvertrag({
        zahlungsweise: zahlungsPayload.zahlungsweise,
        zahlungsart: zahlungsPayload.zahlungsart,
      }),
    );
  }
}
